import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts'

const COLORS = [
  'hsl(217, 91%, 30%)',   // primary blue
  'hsl(142, 76%, 36%)',   // green
  'hsl(0, 84%, 60%)',     // red
  'hsl(38, 92%, 50%)',    // amber
  'hsl(262, 83%, 58%)',   // purple
  'hsl(199, 89%, 48%)',   // cyan
  'hsl(24, 95%, 53%)',    // orange
  'hsl(330, 81%, 60%)',   // pink
]

interface LineChartProps {
  data: Record<string, any>[]
  xKey: string
  lines: { key: string; name?: string; color?: string }[]
  height?: number
  xTickFormatter?: (value: any) => string
  yTickFormatter?: (value: any) => string
  tooltipFormatter?: (value: any) => string
  showGrid?: boolean
  showLegend?: boolean
}

export default function LineChart({
  data,
  xKey,
  lines,
  height = 300,
  xTickFormatter,
  yTickFormatter,
  tooltipFormatter,
  showGrid = true,
  showLegend = true,
}: LineChartProps) {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsLineChart data={data} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
        {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="hsl(214, 32%, 91%)" />}
        <XAxis
          dataKey={xKey}
          tick={{ fontSize: 12, fill: 'hsl(215, 16%, 47%)' }}
          tickFormatter={xTickFormatter}
        />
        <YAxis
          tick={{ fontSize: 12, fill: 'hsl(215, 16%, 47%)' }}
          tickFormatter={yTickFormatter}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'hsl(0, 0%, 100%)',
            border: '1px solid hsl(214, 32%, 91%)',
            borderRadius: '0.5rem',
            fontSize: 12,
          }}
          formatter={tooltipFormatter ? (value: any) => tooltipFormatter(value) : undefined}
        />
        {showLegend && <Legend wrapperStyle={{ fontSize: 12 }} />}
        {lines.map((line, i) => (
          <Line
            key={line.key}
            type="monotone"
            dataKey={line.key}
            name={line.name || line.key}
            stroke={line.color || COLORS[i % COLORS.length]}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
          />
        ))}
      </RechartsLineChart>
    </ResponsiveContainer>
  )
}
